import Link from "next/link";

import { useRouter } from "next/router";
import ArrowIcon from "../icons/ArrowIcon";

const ProductBreadCrumb = ({ Current, parentCategory = null }) => {
  const { locale } = useRouter();
  return (
    <section className="py-3 bg-zinc-50 sm:py-4">
      <div className="flex items-center w-11/12 gap-3 mx-auto overflow-x-auto overflow-y-hidden">
        <Link href="/" className="text-xs font-bold sm:text-sm">
          {locale?.includes("en") ? "Home" : "الرئيسية"}
        </Link>
        {parentCategory?.length
          ? parentCategory?.map((cat, idx) => {
              const link = parentCategory
                ?.slice(0, idx + 1)
                .map((item) => item?.url)
                ?.join("/");
              return (
                <div
                  key={`product-parent-category-${link}`}
                  className="flex items-center justify-center gap-1"
                >
                  <ArrowIcon
                    className={`mt-0.5 size-3 ${
                      locale === "ar" ? "rotate-180" : ""
                    }`}
                  />
                  <Link
                    className="text-xs font-bold min-w-fit line-clamp-1 sm:text-sm"
                    href={`/${link}`}
                  >
                    {cat?.name}
                  </Link>
                </div>
              );
            })
          : null}
        <ArrowIcon
          className={`mt-0.5 size-3 ${locale === "ar" ? "rotate-180" : ""}`}
        />
        <span className="text-xs font-bold line-clamp-1 min-w-fit sm:text-sm">
          {Current}
        </span>
      </div>
    </section>
  );
};

export default ProductBreadCrumb;
